export const STATUS_COLORS = {
  Published: "var(--horizontal-bar-chart--blue)",
  "Invoice Created": "var(--horizontal-bar-chart--blue)",
  "QTN Received": "var(--horizontal-bar-chart--progress)",

  "RFQ Created": "var(--horizontal-bar-chart--success)",
  "Tech Approved": "var(--horizontal-bar-chart--info)",

  "Technical Open": "var(--horizontal-bar-chart--progress)",
  "PR Created": "var( --horizontal-bar-chart--blue)",
  "Tender Created": "var( --horizontal-bar-chart--blue)",

  "PR Approved": "var(--horizontal-bar-chart--light-green)",
  "Invoice Approved": "var(--horizontal-bar-chart--success)",
  "In Release": "var(--horizontal-bar-chart--progress)",
  Cancelled: "var(--horizontal-bar-chart--danger)",
  Acknowledged:"var(--horizontal-bar-chart--ack)",
};

export const FALLBACK_COLORS = [
  "var(--horizontal-bar-chart--indigo)",
  "var(--horizontal-bar-chart--sky)",
  "var(--horizontal-bar-chart--emerald)",
  "var(--horizontal-bar-chart--amber)",
  "var(--horizontal-bar-chart--red)",
  "var(--horizontal-bar-chart--violet)",
  "var(--horizontal-bar-chart--teal)",
  "var(--horizontal-bar-chart--slate)",
];
